export enum EmotionTypeEnum {
	NEUTRAL = 'neutral', // Chatbot is neutral, waiting for interaction with user
	PRESENTATION = 'presentation', // Chatbot presentation emotion
	THINK = 'think', // Chatbot is thinking, considering or awaiting an expected event, like searching for a response
    JOY = 'joy', // Chatbot is happy, feeling a great pleasure
	SADNESS = 'sadness', // Chatbot is sad, feeling an emotional pain
}

export const EmotionTypeFromString: {[id: string]: string } = {
	'neutral': EmotionTypeEnum.NEUTRAL,
	'presentation': EmotionTypeEnum.PRESENTATION,
	'think': EmotionTypeEnum.THINK,
	'joy': EmotionTypeEnum.JOY,
	'sadness': EmotionTypeEnum.SADNESS,

	'Neutral': EmotionTypeEnum.NEUTRAL,
	'Presentation': EmotionTypeEnum.PRESENTATION,
	'Think': EmotionTypeEnum.THINK,
	'Joy': EmotionTypeEnum.JOY,
	'Sadness': EmotionTypeEnum.SADNESS,

	'NEUTRAL': EmotionTypeEnum.NEUTRAL,
	'PRESENTATION': EmotionTypeEnum.PRESENTATION,
	'THINK': EmotionTypeEnum.THINK,
	'JOY': EmotionTypeEnum.JOY,
	'SADNESS': EmotionTypeEnum.SADNESS,
};

export const EmotionIdFromString: {[id: string]: string } = {
	'neutral': `synapse-bot-emo-${EmotionTypeEnum.NEUTRAL}`,
	'presentation': `synapse-bot-emo-${EmotionTypeEnum.PRESENTATION}`,
	'think': `synapse-bot-emo-${EmotionTypeEnum.THINK}`,
	'joy': `synapse-bot-emo-${EmotionTypeEnum.JOY}`,
	'sadness': `synapse-bot-emo-${EmotionTypeEnum.SADNESS}`,

	'Neutral': `synapse-bot-emo-${EmotionTypeEnum.NEUTRAL}`,
	'Presentation': `synapse-bot-emo-${EmotionTypeEnum.PRESENTATION}`,
	'Think': `synapse-bot-emo-${EmotionTypeEnum.THINK}`,
	'Joy': `synapse-bot-emo-${EmotionTypeEnum.JOY}`,
	'Sadness': `synapse-bot-emo-${EmotionTypeEnum.SADNESS}`,

	'NEUTRAL': `synapse-bot-emo-${EmotionTypeEnum.NEUTRAL}`,
	'PRESENTATION': `synapse-bot-emo-${EmotionTypeEnum.PRESENTATION}`,
	'THINK': `synapse-bot-emo-${EmotionTypeEnum.THINK}`,
	'JOY': `synapse-bot-emo-${EmotionTypeEnum.JOY}`,
	'SADNESS': `synapse-bot-emo-${EmotionTypeEnum.SADNESS}`,
};

export default EmotionTypeEnum;
